import { axiosInstance } from ".";

const getReferralsList = async (params) =>
  await axiosInstance.get("/referrals", { params });

const getReferralsRewards = async (params) =>
  await axiosInstance.get("/referral_stats", { params });

export { getReferralsList, getReferralsRewards };
